import { render, staticRenderFns } from "./QFooter.vue?vue&type=template&id=cd4ec00a&"
import script from "./QFooter.vue?vue&type=script&lang=js&"
export * from "./QFooter.vue?vue&type=script&lang=js&"
import style0 from "./QFooter.vue?vue&type=style&index=0&id=cd4ec00a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports